import React from 'react';
import PropTypes from 'prop-types';

import {Stack, IconButton, Tooltip, Zoom} from 'views/components';
import {ContentCopy as ContentCopyIcon} from 'views/icons';
import {translate} from 'views/module';

import GenerateCustomUrl from './GenerateCustomUrl';

const JobProfileUrl = (props) => {
  const {
    jobData,
  } = props;

  const [isCopying, setIsCopying] = React.useState(false);
  const [fullUrl, setFullUrl] = React.useState('');

  const copyJobUrl = async () => {
    setIsCopying(true);
    try {
      await window.navigator.clipboard.writeText(fullUrl);
    } catch (err) {
      // silently fail for now
    } finally {
      setTimeout(() => {
        setIsCopying(false);
      }, 1000);
    }
  };

  return (
    <Stack direction="row" alignItems="center">
      <GenerateCustomUrl jobData={jobData} fullUrl={fullUrl} setFullUrl={setFullUrl} />
      <Tooltip
        title={translate('caregiver.CaregiverDetail.Settings.ProfileUrl.Copy')}
        placement="top"
        TransitionComponent={Zoom}
      >
        <IconButton
          onClick={copyJobUrl}
        >
          <ContentCopyIcon
            sx={{
              color: isCopying ? 'secondary.main' : 'inherit',
            }}
          />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};

JobProfileUrl.propTypes = {
  jobData: PropTypes.object,
};

export default React.memo(JobProfileUrl);
